<div *ngIf="header || content" class="matlist-section" [ngClass]="sectionFaq == 'citishopFaq' ? 'matlist-citishop-background' : ''">
    <button role="button" [attr.aria-expanded]="showContent" class="btn accordion-trigger" [attr.id]="'accordion-'+item" (click)="toggleContent()"
        [ngClass]="showContent ? 'contentExpanded' : 'contentCollapsed'">
        <h3 class="category-title" ><span [innerHTML]="header"></span></h3>
    </button>
    <div [attr.id]="'section-'+item" role="region" [attr.aria-labelledby]="'accordion-'+item" class="category-content content"
        [hidden]="!showContent" [innerHTML]="content"></div>
</div>
